import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { headerItemClass, headerItemIconClass, headerItemLabelClass } from './HeaderItem.styles';

type Props = {
    title: string;
    iconName: IconProp;
    color?: string;
    isActive?: boolean;
    onItemClick?: () => void;
};

const HeaderItem: React.FC<Props> = (props) => {
    return (
        <div
            className={`${headerItemClass} ${props.onItemClick ? 'clickable' : ''} ${props.isActive ? 'active' : ''}`}
            onClick={() => {
                props.onItemClick && props.onItemClick();
            }}
        >
            <div className={headerItemIconClass}>
                <FontAwesomeIcon icon={props.iconName} />
            </div>
            <span className={headerItemLabelClass}>{props.title}</span>
        </div>
    );
};

export default HeaderItem;
